import verifyEmailModule from '../verifyEmailModule';

const verifyEmailResources = {
    templates: {
        verifyEmailContainer: "verify-email-container"
    },
    urls: {
        catalog: "/catalog/",
        home: "/home",
        verifyEmailApi: "/v1/email/verify"
    },
    paramNames: {
        ticket: "ticket"
    }
};

verifyEmailModule.constant("verifyEmailResources", verifyEmailResources);

export default verifyEmailResources;